import _Promise from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/promise";
import _Array$from from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/array/from";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { env, tenvideo } from '@tencent/vft-common';
export default {
  name: 'share-pop',
  data: function data() {
    return {
      env: env,
      shareVisible: false,
      img: ''
    };
  },
  computed: {
    advancedApp: function advancedApp() {
      // 6.0以上app
      return !!(env.isApp && tenvideo.versionCompare(tenvideo.getVersion(), '6.0.0'));
    },
    canShareImg: function canShareImg() {
      if (this.advancedApp) {
        return true;
      } else if (env.isApp && env.isAndroid) {
        return true;
      }

      return false;
    },
    needSaveThenShareImg: function needSaveThenShareImg() {
      // ios app 6.0以下会出保存一次弹窗
      return env.isApp && env.isIos && !this.advancedApp;
    },
    canSaveImg: function canSaveImg() {
      // 手Q或微信
      return !!(env.isMqq || env.isWechat);
    },
    canCutImg: function canCutImg() {
      // 不确定是否能长按保存
      return !(this.canShareImg || this.needSaveThenShareImg || this.canSaveImg);
    }
  },
  watch: {
    shareVisible: function shareVisible(v) {
      if (v) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }

      document.body.appendChild(this.$el);
    }
  },
  methods: {
    shareHandler: function shareHandler() {
      this.img = '';
      this.shareVisible = true;
    },
    picGeneratorFailHandler: function picGeneratorFailHandler(e) {
      window.console.error(e);
    },
    shareLocalImg: function shareLocalImg() {
      var _this = this;

      if (tenvideo.isTenvideo()) {
        if (!this.advancedApp) {
          this.loading.show('', 6000);
        }

        if (this.img) {
          tenvideo.shareLocalImage(this.img, function (res) {
            window.console.log(res);

            _this.loading.hide();
          }, function (err) {
            window.console.error(err);
          });
        } else {
          this.toast('正在抓紧生成中，稍后点击');
        }
      }
    },
    showImage: function () {
      var _showImage = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$refs.generator.generate({
                  autoReplace: false,
                  logging: false,
                  scale: window.devicePixelRatio || 2
                });

              case 3:
                this.img = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                window.console.error(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function showImage() {
        return _showImage.apply(this, arguments);
      }

      return showImage;
    }(),
    filterEmoji: function filterEmoji(str, len) {
      var length = 0,
          strArr = _Array$from(str),
          // ES6的Array.from支持代理对的解析
      strArrlen = strArr.length,
          result = '';

      for (var i = 0; i < strArrlen; i++) {
        var item = strArr[i];
        length++;

        if (escape(item).length > 4) {
          // 中文或表情符编码后长度大于4，按两个字符的宽度计算
          length++;
        }

        result = result.concat(item);

        if (length >= len) {
          if (i == strArrlen - 1) {
            return result;
          }

          result = result.concat('...');
          return result;
        }
      }

      if (length < len) {
        return str;
      }
    },
    img2base64: function img2base64(url, crossOrigin) {
      return new _Promise(function (resolve) {
        var img = new Image();

        img.onload = function () {
          try {
            var c = document.createElement('canvas');
            c.width = img.naturalWidth;
            c.height = img.naturalHeight;
            var cxt = c.getContext('2d');
            cxt.drawImage(img, 0, 0); // 得到图片的base64编码数据

            resolve(c.toDataURL('image/png'));
          } catch (e) {
            window.console.error(e);
            resolve(url);
          }
        };

        img.onerror = function (e) {
          window.console.error(e);
          resolve(url);
        };

        crossOrigin && img.setAttribute('crossOrigin', crossOrigin);
        img.src = url;
      });
    }
  },
  mounted: function mounted() {
    if (this.visible) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};